import { Component, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
  selector: 'topo-comms-left-drawer',
  templateUrl: './left-drawer.component.html',
  styleUrls: ['./left-drawer.component.scss'],
  standalone: false
})
export class NotificationLeftDrawerComponent implements AfterViewInit {
  width = 400;
  @Input() height: string = '100vh';
  @Input() isOpen = false;
  @Input() showOpenCloseHandle = false;
  @Input() handleTop = 86;

  protected canAnimate = false;

  @Output() visibilityChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  openCloseClick(): void {
    this.visibilityChanged.emit(!this.isOpen);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.canAnimate = true;
    });
  }
}
